import { memo } from 'react';
import { Breakpoint } from '../../hooks/useBreakpoint/index.types';
import { TokensIconProps } from './TokensIcon.types';
import useBreakpoint from '../../hooks/useBreakpoint';
import Image from '../../common/Image/Image';

function TokensIcon({ mobileUrl, desktopUrl, ...rest }: TokensIconProps) {
  const breakpoint = useBreakpoint();
  const source = breakpoint === Breakpoint.MOBILE ? mobileUrl : desktopUrl;

  return source && <Image source={source} {...rest} />;
}

export default memo(TokensIcon);
